'use strict'

var separate = require('./separate')

module.exports = function(name){
   return separate(name).toLowerCase()
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/ustring/src/hyphenate.js
 ** module id = 830
 ** module chunks = 0
 **/